module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAASCAYAAACNdSR1AAAAN0lEQVQokWN88fr9fwYiAROxCkcVowMWZE7X5OUYCspyI7GbjCyBjY/hDJgCdIUgwDga3eQqBgCj3g+Xj7xnEAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/layout/xstb1-2.png
// module id = 420
// module chunks = 0